import script from "./tablist.vue?vue&type=script&lang=ts&setup=true"
export * from "./tablist.vue?vue&type=script&lang=ts&setup=true"

import "./tablist.vue?vue&type=style&index=0&id=f150d1a4&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f150d1a4"]])

export default __exports__